module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLabelPosition,
      "code": _vm.ExLabelPositionCode,
      "title": "Label Position",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.8")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("label-position")]), _vm._v(" prop to modify field style.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("\n                You can set the "), _c('code', [_vm._v("defaultFieldLabelPosition")]), _vm._v(" constructor option to override the default style\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExObjectSyntax,
      "code": _vm.ExObjectSyntaxCode,
      "title": "Object syntax",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.0")])]), _vm._v(" "), _c('p', [_vm._v("You can also use object syntax for "), _c('code', [_vm._v("type")]), _vm._v(" and "), _c('code', [_vm._v("message")]), _vm._v(" props just like Vuejs "), _c('code', [_vm._v("class")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAddons,
      "code": _vm.ExAddonsCode,
      "title": "Addons",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("The above cited components are automatically attached together when inside a Field.")]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the control")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Beware of its responsiveness, avoid large groups of addons since they don't break lines.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroups,
      "code": _vm.ExGroupsCode,
      "title": "Groups"
    }
  }, [_c('p', [_vm._v("You can group those components together with the "), _c('code', [_vm._v("grouped")]), _vm._v(" property.")]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the control")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroupExpanded,
      "code": _vm.ExGroupExpandedCode,
      "title": "Nested groups"
    }
  }, [_c('p', [_vm._v("\n                Nested Fields can be grouped as well,\n                you have to use the "), _c('code', [_vm._v("expanded")]), _vm._v(" prop "), _c('u', [_vm._v("on the Field")]), _vm._v(" to "), _c('b', [_vm._v("fill up the remaining space")]), _vm._v(".\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExGroupMultiline,
      "code": _vm.ExGroupMultilineCode,
      "title": "Responsive groups",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                Add the "), _c('code', [_vm._v("group-multiline")]), _vm._v(" prop to allow controls to fill up "), _c('b', [_vm._v("multiple lines")]), _vm._v(".\n                This is ideal for a long list of controls.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPositions,
      "code": _vm.ExPositionsCode,
      "title": "Positions"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("position")]), _vm._v(" prop to modify its alignment.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCombineAddonsGroups,
      "code": _vm.ExCombineAddonsGroupsCode,
      "title": "Combining addons and groups"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHorizontal,
      "code": _vm.ExHorizontalCode,
      "title": "Horizontal"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("horizontal")]), _vm._v(" prop for aligning label and control in horizontal forms.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Each child element of a "), _c('code', [_vm._v("<b-field horizontal/>")]), _vm._v(" will be\n                automatically wrapped inside a "), _c('code', [_vm._v("Field")]), _vm._v(" component.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomClass,
      "code": _vm.ExCustomClassCode,
      "title": "Label classes"
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("custom-class")]), _vm._v(" prop to adjust the styling of the label.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLabelSlot,
      "code": _vm.ExLabelSlotCode,
      "title": "Label slot"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("Use the "), _c('code', [_vm._v("label")]), _vm._v(" slot for complex labels with HTML content or components. Note it overrides the "), _c('code', [_vm._v("label")]), _vm._v(" prop.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("These components should be used as a "), _c('strong', [_vm._v("direct child")]), _vm._v(" of Field:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Autocomplete")]), _vm._v(" "), _c('li', [_vm._v("Checkbox Button")]), _vm._v(" "), _c('li', [_vm._v("Datepicker")]), _vm._v(" "), _c('li', [_vm._v("Input")]), _vm._v(" "), _c('li', [_vm._v("Radio Button")]), _vm._v(" "), _c('li', [_vm._v("Select")]), _vm._v(" "), _c('li', [_vm._v("Taginput")]), _vm._v(" "), _c('li', [_vm._v("Timepicker")]), _vm._v(" "), _c('li', [_vm._v("Upload")]), _vm._v(" "), _c('li', [_c('code', [_vm._v(".control")]), _vm._v(" elements (html class)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbdffa3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/Field.vue
// module id = 1404
// module chunks = 5